export { default } from './createGenerateClassName';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/createGenerateClassName/index.js
// module id = 236
// module chunks = 0